<div class="ads-container">
  <div class="header-section">
    <h3>Elanlarım</h3>
    <button class="btn-create" (click)="createNewAd()">
      <i class="fas fa-plus"></i> Yeni elan
    </button>
  </div>

  <div class="header-actions">
    <div class="tabs">
      @for (tab of tabs; track tab) {
        <button [class.active]="activeTab === tab" (click)="setActiveTab(tab)">
          {{ tab }}
        </button>
      }
    </div>
    <div class="view-controls">
      <button class="btn-filter">
        <i class="fas fa-filter"></i> Filterlər
      </button>
      <div class="view-toggle">
        <button [class.active]="viewMode === 'grid'" (click)="viewMode = 'grid'" title="Grid">
          <i class="fas fa-th-large"></i>
        </button>
        <button [class.active]="viewMode === 'list'" (click)="viewMode = 'list'" title="List">
          <i class="fas fa-list"></i>
        </button>
      </div>
    </div>
  </div>

  @if (isLoading) {
    <div class="loading-state">
      Yüklənir...
    </div>
  } @else if (filteredAds.length > 0) {
    <div class="ads-grid" [class.list-view]="viewMode === 'list'">
      @for (ad of filteredAds; track ad.id) {
        <div class="ad-card">
          <div class="ad-image">
            <img [src]="ad.previewImageUrl || 'assets/images/no-image.png'" alt="Ad Image">
            <span class="status-badge" [ngClass]="getStatusClass(ad)">
              {{ getStatusLabel(ad) }}
            </span>
          </div>
          <div class="ad-info">
            <div class="price">{{ ad.price | number }} ₼</div>
            <div class="title">{{ ad.propertyType.name }}, {{ ad.areaSquareMeters }} m²</div>
            <div class="location">
              <i class="fas fa-map-marker-alt"></i> {{ ad.address }}
            </div>
            <div class="meta-info">
              <span class="date">{{ ad.createdDate | date:'dd.MM.yyyy' }}</span>
              <span class="views"><i class="fas fa-eye"></i> {{ ad.viewCount }}</span>
            </div>
            <div class="card-actions">
              <button class="btn-action" title="Bax" (click)="viewAd(ad.id)">Bax</button>
              <button class="btn-action" title="Redaktə et" (click)="editAd(ad.id)">Redaktə et</button>
              <button class="btn-action"
                      [title]="isAdPaused(ad) ? 'Bərpa et' : 'Dayandır'"
                      (click)="isAdPaused(ad) ? confirmRestore(ad.id) : confirmPause(ad.id)">
                {{ isAdPaused(ad) ? 'Bərpa et' : 'Dayandır' }}
              </button>
              <button class="btn-action btn-delete" title="Sil">Sil</button>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-folder-open"></i>
      </div>
      <p>Nəticə tapılmadı. İlk elanını indi yarat.</p>
      <button class="btn-primary" (click)="createNewAd()">Elan yerləşdir</button>
    </div>
  }

  <div class="modal-overlay" *ngIf="showPauseModal">
    <div class="modal-content">
      <div class="modal-icon warning">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <h4>Elanı dayandırmaq istədiyinizə əminsiniz?</h4>
      <p>Elan dayandırıldıqdan sonra saytda görünməyəcək.</p>
      <div class="modal-actions">
        <button class="btn-yes" (click)="pauseAd()">Bəli, dayandır</button>
        <button class="btn-no" (click)="closeModal()">Xeyr</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showRestoreModal">
    <div class="modal-content">
      <div class="modal-icon info">
        <i class="fas fa-info-circle"></i>
      </div>
      <h4>Elanı bərpa etmək istədiyinizə əminsiniz?</h4>
      <p>Elan bərpa edildikdən sonra yenidən saytda görünəcək.</p>
      <div class="modal-actions">
        <button class="btn-yes" (click)="restoreAd()">Bəli, bərpa et</button>
        <button class="btn-no" (click)="closeModal()">Xeyr</button>
      </div>
    </div>
  </div>
</div>
